<template>
	<div>
		<div class="creat_ttk">
				<div class="f-wh-4-s1">
					<div class="creat_outk">
						<h6>地图范围设置</h6>
						<form id="creatForm" class="creat_form" name="creatForm">
							<p>
								<label>选择中心点：</label>
								<input type="text" name="taskname" placeholder="请点击在地图上选择中心点" /></p>
							<p>
								<label>半径范围：</label>
								<select>
									<option selected hidden disabled value="">请选择半径范围</option>
									<option>11</option>
									<option>22</option>
								</select>
							</p>
							<button class="submit_task" @click="closedig">完成设置</button>
						</form>
					</div>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods:{
			closedig(){
				this.$emit('func',false)
			},
		}
	}
</script>

<style scoped="scoped">
	.creat_form p label{color: #ffffff; width: 6em; text-align: right; display: inline-block;}
</style>
